import { IconWrapper } from '../runtime';
export default IconWrapper('wechat', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M11.0755 5.40961C10.6421 3.46567 8.46851 2 6.01935 2C3.2518 2 1 3.85616 1 6.13758C1 7.3616 1.64964 8.46451 2.88085 9.33418C2.78802 9.6026 2.51593 10.8006 2.51593 10.8006C2.51593 10.8006 4.05552 10.2049 4.36874 10.0541L4.56726 10.0929L4.57146 10.0937C5.06577 10.1914 5.49321 10.2759 6.01935 10.2759C6.17466 10.2759 6.63807 10.1775 6.63807 10.1775M10.7047 12.585C11.1873 12.585 11.6758 12.4731 12.1143 12.3675C12.3762 12.5052 13.5987 13 13.5987 13C13.5987 13 13.429 12.0038 13.3533 11.7616C14.4167 10.9533 15 9.98628 15 9.02357C15 6.90197 12.8127 5.42232 10.7047 5.42236C8.44545 5.42239 6.38904 7.05193 6.38904 8.92791C6.38904 11.1031 8.55526 12.585 10.7047 12.585Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M4.5 5.25C4.91421 5.25 5.25 4.91421 5.25 4.5C5.25 4.08579 4.91421 3.75 4.5 3.75C4.08579 3.75 3.75 4.08579 3.75 4.5C3.75 4.91421 4.08579 5.25 4.5 5.25ZM7.25 5.25C7.66421 5.25 8 4.91421 8 4.5C8 4.08579 7.66421 3.75 7.25 3.75C6.83579 3.75 6.5 4.08579 6.5 4.5C6.5 4.91421 6.83579 5.25 7.25 5.25ZM10.25 8.25C10.25 8.66421 9.91421 9 9.5 9C9.08579 9 8.75 8.66421 8.75 8.25C8.75 7.83579 9.08579 7.5 9.5 7.5C9.91421 7.5 10.25 7.83579 10.25 8.25ZM11.75 9C12.1642 9 12.5 8.66421 12.5 8.25C12.5 7.83579 12.1642 7.5 11.75 7.5C11.3358 7.5 11 7.83579 11 8.25C11 8.66421 11.3358 9 11.75 9Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});